import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MoleculeBg from "@/components/brand/MoleculeBg";

export default function CategoryCard({ collection, count }) {
  return (
    <Link
      to={`/category/${collection.slug}`}
      className="group relative block overflow-hidden rounded-sm bg-[#1E2A44] p-8 md:p-10 min-h-[280px] flex flex-col justify-end"
      data-testid={`category-card-${collection.slug}`}
    >
      <MoleculeBg
        className="absolute -right-10 -top-10 w-[65%] h-[65%] transition-transform duration-[1200ms] ease-out group-hover:scale-110 group-hover:rotate-3"
        color={collection.accent}
        opacity={0.22}
      />
      <div className="absolute top-8 left-8 md:left-10">
        <span className="overline !text-[#D8BE87]">Research Collection</span>
        {typeof count === "number" && (
          <span className="ml-3 text-xs text-[#8B90A0]">{count} products</span>
        )}
      </div>
      <div className="relative z-10">
        <h3 className="font-serif text-3xl md:text-4xl text-[#F7F4EF] leading-tight">
          {collection.name}
        </h3>
        <p className="mt-3 text-sm text-[#B9BCC4] max-w-md leading-relaxed">
          {collection.description}
        </p>
        <span className="mt-6 inline-flex items-center gap-2 text-sm text-[#D8BE87] font-medium">
          View Products
          <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1.5" />
        </span>
      </div>
    </Link>
  );
}
